module.exports = __webpack_public_path__ + "img/prop-rock-2-left.1c3dd34c.png";